export const SHARING_ENABLED = "enable_kb_sharing"
export const JS_AGENT_REF_REQUIRED = "enable_javascript_agent"
export const BSS_AGENT_REF_REQUIRED = "enable_bss_agent"
export const NEW_WORKPLACE_ENABLED = "new_workplace_enabled"
export const MASS_MAILING_ENABLED = "enable_bulk_mailing"
